import React from "react";

import { AlertDialogBackground, DivColumn, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsTexts from "../../../constants/ConstantsTexts";

import "./WidgetAlertDialogFrozenTerminalBlocked.css";

const WidgetAlertDialogFrozenTerminalBlocked = ({ onClose }) => {
  return (
    <AlertDialogBackground onClick={onClose}>
      <DivColumn className="alert-dialog-frozen-terminal-blocked" onClick={(e) => e.stopPropagation()}>
        <DivColumn className="alert-dialog-frozen-terminal-blocked-content">
          <ParagraphText className="alert-dialog-frozen-terminal-blocked-title">{ConstantsTexts.CODE_252}</ParagraphText>
          <ParagraphText className="alert-dialog-frozen-terminal-blocked-message">{ConstantsTexts.CODE_251}</ParagraphText>
        </DivColumn>
        <DivColumn className="alert-dialog-frozen-terminal-blocked-button" onClick={onClose}>
          <ParagraphText className="alert-dialog-frozen-terminal-blocked-button-text">{ConstantsTexts.CODE_253}</ParagraphText>
        </DivColumn>
      </DivColumn>
    </AlertDialogBackground>
  );
};

export default WidgetAlertDialogFrozenTerminalBlocked;
